import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  height: ', 'px;\n'], ['\n  height: ', 'px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  margin: auto;\n  padding: 10px;\n  text-align: center;\n  width: 50%;\n'], ['\n  margin: auto;\n  padding: 10px;\n  text-align: center;\n  width: 50%;\n']);

import styled from 'styled-components';
import { gridSize, math } from '@atlaskit/theme';

export var EmptyViewWithFixedHeight = styled.div(_templateObject, math.multiply(gridSize, 18));

export var EmptyViewContainer = styled.div(_templateObject2);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/dynamic-table/dist/esm/styled/EmptyBody.js
// module id = 903
// module chunks = 0